<template>
    <div>
        <el-form-item label="Pokaż pasek filtrowania">
            <el-switch v-model="form.show_filter_bar"/>
        </el-form-item>
        <div class="sections">
            <el-collapse class="formset__list">
                <div v-for="section, i in form.sections" class="formset__item">
                    <el-collapse-item :name="i">
                        <template slot="title">
                            <formset-header :label="section.title_pl || 'Nowa sekcja'"
                                            :items.sync="form.sections"
                                            :errors="checkForErrors(errors.sections, [i])"
                                            :index="i"/>
                        </template>
                        <div class="inline-form-group">
                            <el-form-item label="Tytuł"
                                          :error="errors.sections && errors.sections[i] && errors.sections[i][addLanguageSuffix('title')]">
                                <el-input v-model="section[addLanguageSuffix('title')]">
                                </el-input>
                            </el-form-item>
                        </div>
                        <el-form-item label="Galerie (kolejność względem dodawania)"
                                      :error="errors.sections && errors.sections[i] && errors.sections[i]['galleries']">

                            <el-select v-model="section.galleries"
                                       multiple
                                       placeholder="Wybierz galerie">
                                <el-option-group v-for="group in groupedGalleries"
                                                 :key="group.label"
                                                 :label="group.label">
                                    <el-option v-for="item in group.options"
                                               :key="item.id"
                                               :label="item.name_pl"
                                               :value="item.id">
                                    </el-option>
                                </el-option-group>
                            </el-select>
                        </el-form-item>
                    </el-collapse-item>
                </div>
            </el-collapse>
            <el-button @click="addSection">+ sekcja</el-button>
        </div>
    </div>
</template>
<script>
    import {Folder} from '@/api'

    export default {
        props: ['form', 'errors'],
        data () {
            return {
                galleries: []
            }
        },
        mounted () {
            this.fetchData()
        },
        computed: {
            groupedGalleries () {
                const groupedDict = {}

                const setDefault = gallery => groupedDict[gallery.edition] = []
                this.galleries.forEach(setDefault)

                const pushGallery = gallery => groupedDict[gallery.edition].push(gallery)
                this.galleries.forEach(pushGallery)

                const createProperFormat = key => ({label: this.editionLabels[key], options: groupedDict[key]})
                const groupedArray = Object.keys(groupedDict).map(createProperFormat)

                return groupedArray
            },
            editionLabels () {
                const mappedEditions = {}
                const mapEdition = edition => mappedEditions[edition.id] = edition.year.toString()
                this.$store.state.editions.forEach(mapEdition)
                return mappedEditions
            }
        },
        methods: {
            fetchData () {
                this.$store.dispatch('fetchEditions')
                Folder.all().then(response => {
                    this.galleries = response.data
                })
            },
            addSection () {
                const blankObject = {}
                if (!Array.isArray(this.form.sections)) {
                    this.$emit('update:form', {
                        ...this.form,
                        sections: [
                            blankObject
                        ]
                    })
                } else {
                    this.form.sections.push(blankObject)
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// GalleriesListWidget.vue?209c13c0